// @flow
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

const TOP_OFFSET = 100;

export const WelcomeText: any = styled.h1`
  ${getFont(5.25)}
  font-weight: 100;

  margin-top: ${TOP_OFFSET}px;

  strong {
    font-weight: 300;
  }

  ${maxMediaQueries.tablet`
    ${getFont(4)}
  `}
`;

export const Logo: any = styled.div`
  position: absolute;
  bottom: 5px;
  right: 0;
  width: fit-content;

  ${maxMediaQueries.tablet`
    position: relative;
    height: 100%;
    display: flex;
    align-items: flex-end;

    svg {
      width: 120px;
    }
  `};
`;

export const HeroWrapper: any = styled.div`
  color: white;
  padding: 50px 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;

  height: 100%;
  width: 95%;

  ${({ limited, narrow }) => (limited ? 'max-width: 1000px;' : narrow ? 'max-width: 1200px;' : '')}

  ${maxMediaQueries.miniDesktop`
    > div {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
    }
  `}
`;

export const NavBar: any = styled.nav`
  display: flex;
  align-items: center;
  margin-top: 20px;

  ${maxMediaQueries.tablet`
    margin-top: 12px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: calc(100% + 30px); /* 100% + 2 * 15px parent padding */
    margin-left: -15px;
    padding-left: 15px;
    padding-right: 15px;
    
    /* Hide scrollbar */
    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none; /* Firefox */
  `}
`;

export const HeroContainer: any = styled.div`
  background: ${({ theme }) => theme.plus.background};
  width: 100%;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  position: sticky;
  z-index: 100;

  margin-top: -${TOP_OFFSET}px;
  height: ${200 + TOP_OFFSET}px;
  ${({ $withHello }) =>
    !$withHello &&
    `
    height: ${70 + TOP_OFFSET}px;
    top: 100px;

    ${HeroWrapper} {
      padding: 10px 0;
    }
  `}

  transition: transform 0.25s cubic-bezier(0.49, 0.42, 0.52, 0.98);

  transform: translateY(
    ${props =>
  (props.omninavState === 'opened'
    ? props.$withHello
      ? 0
      : -140
    : props.$withHello
      ? 0
      : -195 - props.theme.navHeight)}px
  );

  ${maxMediaQueries.tablet`
    ${({ $withHello }) =>
    (!$withHello
      ? `
      height: ${50 + TOP_OFFSET}px;
      
      ${Logo} {
        display: none;
      }

      ${NavBar} {
        margin-top: 0;
      }
      `
      : `
      height: ${150 + TOP_OFFSET}px; 
      `)}

       transform: translateY(${props =>
    (props.omninavState === 'opened'
      ? props.$withHello
        ? 0
        : -105
      : props.$withHello
        ? 0
        : -175 - props.theme.navHeight)}px);
  `}

  @media (max-width: 800px) {
    ${({ $withHello }) => (!$withHello ? `height: ${40 + TOP_OFFSET}px;` : `height: ${160 + TOP_OFFSET}px; `)}

    transform: translateY(
      ${props =>
  (props.omninavState === 'opened'
    ? props.$withHello
      ? 0
      : -140
    : props.$withHello
      ? 0
      : -170 - props.theme.navHeight)}px
    );
  }

  @media (max-width: 500px) {
    ${({ $withHello }) => (!$withHello ? `height: ${50 + TOP_OFFSET}px;` : `height: ${150 + TOP_OFFSET}px; `)}

    transform: translateY(
      ${props =>
  (props.omninavState === 'opened'
    ? props.$withHello
      ? 0
      : -105
    : props.$withHello
      ? 0
      : -175 - props.theme.navHeight)}px
    );
  }
`;

export const NavItem: any = styled.a`
  color: ${({ $active = false, theme }) => ($active ? theme.plus.primary : theme.plus.font)};
  cursor: pointer;
  text-decoration: none;
  ${getFont(0)}
  font-weight: ${({ $active = false }) => ($active ? 600 : 400)};

  border-left: 1px solid rgba(255, 255, 255, 0.3);
  padding-left: 20px;
  padding-right: 20px;

  &:first-child {
    border-left: none;
    padding-left: 0;
  }

  ${maxMediaQueries.miniDesktop`
    ${getFont(-1)}
    padding-left: 10px;
    padding-right: 10px;
  `}

  ${maxMediaQueries.phone`
    ${({ $active }) => $active && 'color: #fff;'}
  `}
`;
